import {handleActions} from 'redux-actions';
import {Map} from 'immutable';
import moment from 'moment-timezone';

import * as PeopleActions from 'web-app/react/institution-people/people/actions';
import {updateReferenceMap} from 'web-app/react/entities/factory/reducer-factory';
import * as StatusActions from 'web-app/react/entities/statuses/actions';
import * as LeaveRegistrationActions from 'web-app/react/profile/child-profile/leave-registration/actions';
import * as LeaveRegistrationConstants from 'web-app/react/profile/child-profile/leave-registration/constants';
import {LeaveType} from 'web-app/react/leave-types/leave-type';

import {GROUP_BY_KEYS} from './constants';

function rangeIncludesToday(start, end) {
    const startMoment = moment(start).startOf('day');
    const endMoment = moment(end).endOf('day');
    const today = moment();
    return today.isBetween(startMoment, endMoment);
}

export default handleActions(
    {
        [LeaveRegistrationActions.updateSuccess.type]: (state, {payload}) => {
            if (
                payload.personType === LeaveRegistrationConstants.CHILD &&
                rangeIncludesToday(payload.startDate, payload.endDate)
            ) {
                const newEntityMap = state.entityMap.mergeDeep({
                    [payload.personId]: new Map({
                        isSick: payload.leaveType === LeaveType.Sick,
                        hasVacation: payload.leaveType === LeaveType.Vacation,
                        isAbsent: payload.leaveType === LeaveType.Absent,
                    }),
                });
                const newReferenceMap = updateReferenceMap(state.referenceMap, newEntityMap.toList(), GROUP_BY_KEYS);

                return state.merge({
                    entityMap: newEntityMap,
                    referenceMap: newReferenceMap,
                });
            }
            return state;
        },
        [StatusActions.endStatusSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.childIds.reduce((acc, childId) => {
                const child = acc.get(childId);
                const updatedStatuses = child.statusRegistrations.filter(
                    s => s.statusConfig.statusConfigId !== payload.statusConfigId,
                );
                const updatedChild = child.merge({statusRegistrations: updatedStatuses});
                return acc.set(childId, updatedChild);
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [StatusActions.applyStatusSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.childIds.reduce((acc, childId) => {
                const child = acc.get(childId);
                const newStatus = {statusConfig: {statusConfigId: payload.statusConfigId}};
                const updatedStatuses = child.statusRegistrations.push(newStatus);
                const updatedChild = child.merge({statusRegistrations: updatedStatuses});
                return acc.set(childId, updatedChild);
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [PeopleActions.checkinSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.childrenIds.reduce((acc, childId) => {
                const child = acc.get(childId);
                const updatedValues = {checkedIn: true};
                return acc.set(childId, child.merge(updatedValues));
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
        [PeopleActions.createChildSuccess.type]: (state, {payload}) => {
            const newEntityMap = state.entityMap.set(payload.child.id, payload.child);
            const newReferenceMap = updateReferenceMap(state.referenceMap, newEntityMap.toList(), GROUP_BY_KEYS);

            return state.merge({
                entityMap: newEntityMap,
                referenceMap: newReferenceMap,
            });
        },
        [PeopleActions.checkoutSuccess.type]: (state, {payload}) => {
            const newEntityMap = payload.childrenIds.reduce((acc, childId) => {
                const child = acc.get(childId);
                const updatedValues = {checkedIn: false, behaviors: []};
                return acc.set(childId, child.merge(updatedValues));
            }, state.entityMap);

            return state.merge({
                entityMap: newEntityMap,
            });
        },
    },
    null,
);
